"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomerProductReturnStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useCustomerProductReturnStore = (0, pinia_1.defineStore)('customerProductReturnStore', {
    state: () => ({
        submittedProductReturns: []
    }),
    getters: {
        submittedProductItemsReturns: (state) => {
            return state.submittedProductReturns;
        },
    },
    actions: {
        addProductItem(item) {
            this.submittedProductReturns.push(item);
        },
        removeSubmittedProductItem(item) {
            const indexToRemove = this.submittedProductReturns.findIndex(obj => obj.productId === item.productId);
            this.submittedProductReturns.splice(indexToRemove, 1);
        },
        createCustomerProductReturns(router, axaptaId, customerData, submittedItems) {
            let requestData = {
                axaptaId: axaptaId,
                customerData: customerData,
                submittedItems: submittedItems
            };
            let options = { body: JSON.stringify(requestData), method: 'POST' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_create_customer_product_returns_api' }).href, options).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        getCustomerProductReturns(router, params, customerId) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({
                    name: 'admin_get_customer_product_returns_api',
                    query: {
                        customerId: customerId,
                        ...params
                    }
                }).href)
                    .then((response) => {
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        },
    },
});
